import _sortBy from 'lodash/sortBy';
import TYPES from '../action-types';
import * as helpers from '../helpers/customFields';

const matchesRemoveTarget = (item, { title }) => item.title === title;

const fakeItems = [
  { isTmp: true, title: '1' },
  { isTmp: true, title: '2' },
  { isTmp: true, title: '3' },
  { isTmp: true, title: '4' },
  { isTmp: true, title: '5' },
];

const defaultState = {
  isLoaded: false,
  isAdding: false,
  items: [],
  groups: [],
  filtredGroups: null,
  error: null,
  addError: null,
  searchQuery: '',
};

export default function (state = defaultState, action) {
  const { type, payload, error } = action;

  switch (type) {
  case TYPES.CUSTOM_FIELDS.FETCH.START: {
    return {
      ...state,
      isLoaded: false,
      items: [...fakeItems],
      groups: [...fakeItems],
      error: null,
    };
  }
  case TYPES.CUSTOM_FIELDS.FETCH.COMPLETE: {
    return {
      ...state,
      isLoaded: true,
      items: _sortBy(payload.items, ['order']),
      groups: helpers.createGroups(_sortBy(payload.items, ['order'])),
    };
  }
  case TYPES.CUSTOM_FIELDS.FETCH.FAILED: {
    return {
      ...state,
      isLoaded: true,
      items: [],
      groups: [],
      error,
    };
  }

  case TYPES.CUSTOM_FIELDS.ADD.START: {
    const newItem = { ...payload.item, isTmp: true };
    const newItems = [...state.items.map((item) => {
      if (item.order >= newItem.order) {
        return { ...item, order: (item.order || 0) + 1 };
      }
      return item;
    })];
    newItems.push(newItem);

    return {
      ...state,
      isAdding: true,
      items: _sortBy(newItems, ['order']),
      groups: helpers.createGroups(_sortBy(newItems, ['order'])),
      addError: null,
    };
  }
  case TYPES.CUSTOM_FIELDS.ADD.COMPLETE: {
    const newItem = payload.item;
    const newItems = [...state.items.map((item) => {
      if (item.order === newItem.order) {
        const { isTmp, ...other } = item; // eslint-disable-line
        return { ...other };
      }
      return item;
    })];

    return {
      ...state,
      isAdding: false,
      items: newItems,
      groups: helpers.createGroups(newItems),
    };
  }
  case TYPES.CUSTOM_FIELDS.ADD.FAILED: {
    const filteredItems = _sortBy(state.items, ['order']).filter((item) => {
      if (item.title !== payload.item.title) return true;
      if (item.title === payload.item.title && !item.isTmp) return true;
      return false;
    });
    return {
      ...state,
      isAdding: false,
      items: filteredItems,
      groups: helpers.createGroups(filteredItems),
      addError: error,
    };
  }

  case TYPES.CUSTOM_FIELDS.REMOVE_ERROR: {
    return {
      ...state,
      error: null,
      addError: null,
    };
  }

  case TYPES.CUSTOM_FIELDS.REMOVE.START: {
    const nextItems = state.items.map((item) => (
      matchesRemoveTarget(item, payload) ? { ...item, isTmp: true } : item
    ));
    return {
      ...state,
      items: nextItems,
      groups: helpers.createGroups(nextItems),
    };
  }
  case TYPES.CUSTOM_FIELDS.REMOVE.COMPLETE: {
    const nextItems = state.items.filter((item) => !matchesRemoveTarget(item, payload));
    return {
      ...state,
      items: nextItems,
      groups: helpers.createGroups(nextItems),
      filtredGroups: state.filtredGroups
        ? state.filtredGroups.map((group) => group.filter((item) => !matchesRemoveTarget(item, payload)))
        : null,
    };
  }
  case TYPES.CUSTOM_FIELDS.REMOVE.FAILED: {
    const nextItems = state.items.map((item) => {
      if (matchesRemoveTarget(item, payload)) {
        const { isTmp, ...other } = item; // eslint-disable-line
        return { ...other };
      }
      return item;
    });
    return {
      ...state,
      items: nextItems,
      groups: helpers.createGroups(nextItems),
      error,
    };
  }

  case TYPES.CUSTOM_FIELDS.UPDATE.START: {
    const { titles } = payload;
    return {
      ...state,
      items: state.items.map((item) => (titles.includes(item.title) ? { ...item, isUpdating: true } : item)),
    };
  }
  case TYPES.CUSTOM_FIELDS.UPDATE.COMPLETE: {
    const { titles, key, value } = payload;
    const handleField = (field) => {
      if (titles.includes(field.title)) {
        const { isUpdating, ...data } = field; // eslint-disable-line
        return { ...data, [key]: value };
      }
      return field;
    };
    const nextItems = state.items.map(handleField);
    return {
      ...state,
      items: nextItems,
      groups: helpers.createGroups(nextItems),
      filtredGroups: state.filtredGroups
        ? state.filtredGroups.map((group) => group.map(handleField))
        : null,
    };
  }
  case TYPES.CUSTOM_FIELDS.UPDATE.FAILED: {
    const { titles } = payload;
    const nextItems = state.items.map((item) => {
      if (titles.includes(item.title)) {
        const { isUpdating, ...data } = item; // eslint-disable-line
        return { ...data };
      }
      return item;
    });
    return {
      ...state,
      items: nextItems,
      groups: helpers.createGroups(nextItems),
    };
  }

  case TYPES.CUSTOM_FIELDS.UPDATE_ONE.START: {
    const { customField } = payload;
    const nextItems = state.items.map(
      (item) => (customField.title === item.title ? { ...item, isUpdating: true } : item),
    );
    return {
      ...state,
      items: nextItems,
      groups: helpers.createGroups(nextItems),
    };
  }
  case TYPES.CUSTOM_FIELDS.UPDATE_ONE.CANCELLED: {
    const { customField } = payload;
    const nextItems = state.items.map(
      (item) => (customField.title === item.title ? { ...item, isUpdating: false } : item),
    );
    return {
      ...state,
      items: nextItems,
      groups: helpers.createGroups(nextItems),
    };
  }
  case TYPES.CUSTOM_FIELDS.UPDATE_ONE.COMPLETE: {
    const { customField } = payload;
    const handleField = (field) => {
      if (customField.title === field.title) {
        const { isUpdating, ...data } = field; // eslint-disable-line
        if (customField.type !== 'enum') {
          delete data.options;
          delete data.multiple;
        }
        return { ...data, ...customField };
      }
      return field;
    };
    const nextItems = state.items.map(handleField);
    return {
      ...state,
      items: nextItems,
      groups: helpers.createGroups(nextItems),
      filtredGroups: state.filtredGroups
        ? state.filtredGroups.map((group) => group.map(handleField))
        : null,
    };
  }
  case TYPES.CUSTOM_FIELDS.UPDATE_ONE.FAILED: {
    const { customField } = payload;
    const nextItems = state.items.map((item) => {
      if (customField.title === item.title) {
        const { isUpdating, ...data } = item; // eslint-disable-line
        return { ...data };
      }
      return item;
    });
    return {
      ...state,
      items: nextItems,
      groups: helpers.createGroups(nextItems),
    };
  }

  case TYPES.CUSTOM_FIELDS.IMPORT.START: {
    return {
      ...state,
      isLoaded: false,
      items: [...fakeItems],
      groups: helpers.createGroups([...fakeItems]),
    };
  }
  case TYPES.CUSTOM_FIELDS.IMPORT.COMPLETE: {
    return {
      ...state,
      items: payload.items,
      groups: helpers.createGroups(payload.items),
      isLoaded: true,
    };
  }
  case TYPES.CUSTOM_FIELDS.IMPORT.FAILED: {
    return {
      ...state,
      isLoaded: true,
      items: [],
      groups: [],
      error,
    };
  }

  case TYPES.CUSTOM_FIELDS.MOVE.START: {
    const nextItems = state.items.map((item) => ({ ...item, isUpdating: true }));
    return {
      ...state,
      items: nextItems,
      groups: helpers.createGroups(nextItems),
    };
  }
  case TYPES.CUSTOM_FIELDS.MOVE.COMPLETE: {
    return {
      ...state,
      items: payload.items,
      groups: helpers.createGroups(payload.items),
    };
  }
  case TYPES.CUSTOM_FIELDS.MOVE.FAILED: {
    const nextItems = state.items.map((item) => {
      const { isUpdating, ...data } = item; // eslint-disable-line
      return data;
    });
    return {
      ...state,
      items: nextItems,
      groups: helpers.createGroups(nextItems),
      error,
    };
  }

  case TYPES.CUSTOM_FIELDS.SEARCH: {
    return {
      ...state,
      searchQuery: payload.value,
      items: state.items,
      filtredGroups: payload.value
        ? helpers.createGroups(helpers.makeSearchItems(state.items, payload.value))
        : null,
    };
  }

  default: {
    return state;
  }
  }
}
